import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "delivery-show" }

import { onBeforeUnmount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { deliveryStore } from '@/stores/delivery'
import PageTitleBar from '@/components/PageTitleBar.vue'
import DeliveryDetailsCard from '@/views/delivery/cards/DeliveryDetailsCard.vue'
import DeliveryRoomsCard from '@/views/delivery/cards/DeliveryRoomsCard.vue'
import DeliveryGeneralChecksCard from '@/views/delivery/cards/DeliveryGeneralChecksCard.vue'
import DeliveryMetersCard from '@/views/delivery/cards/DeliveryMetersCard.vue'
import InspectionFooterCard from '@/views/delivery/cards/InspectionFooterCard.vue'
import DeliveryFooterCard from '@/views/delivery/cards/DeliveryFooterCard.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Delivery',
  setup(__props) {

const route = useRoute()
const router = useRouter()

onMounted(() => {
  deliveryStore().getDelivery(route.params.deliveryId.toString())
})

onBeforeUnmount(() => {
  deliveryStore().delivery = null
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageTitleBar, null, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(deliveryStore)().delivery ? `${_unref(deliveryStore)().delivery.type_label} - #${_unref(deliveryStore)().delivery.id}` : `Aan het laden..`), 1)
      ]),
      subtitle: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(deliveryStore)().delivery?.building ? _unref(deliveryStore)().delivery.building.project.name + ' - Bouwnummer ' + _unref(deliveryStore)().delivery.building.number : ''), 1)
      ]),
      buttons: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Deliveries' })))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Terug naar overzicht")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { gutter: [16, 16] }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          xs: {span: 24},
          sm: {span: 24},
          md: {span: 24},
          lg: {span: 24}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(DeliveryDetailsCard)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_unref(deliveryStore)().delivery)
              ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(DeliveryRoomsCard)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(deliveryStore)().delivery && _unref(deliveryStore)().delivery.inspection_status === 4)
              ? (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(DeliveryGeneralChecksCard)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(deliveryStore)().delivery && _unref(deliveryStore)().delivery.inspection_status === 4)
              ? (_openBlock(), _createBlock(_component_a_row, { key: 2 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(DeliveryMetersCard)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(deliveryStore)().delivery && _unref(deliveryStore)().delivery.inspection_status !== 4)
              ? (_openBlock(), _createBlock(_component_a_row, { key: 3 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(InspectionFooterCard)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(deliveryStore)().delivery && _unref(deliveryStore)().delivery.inspection_status === 4)
              ? (_openBlock(), _createBlock(_component_a_row, { key: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(DeliveryFooterCard)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})